export const productImageMaxSizeKb = 1024

export const productTitleMaxLength = 255
